export const USER_LOGGED_IN_DETAILS = "USER_LOGGED_IN_DETAILS";
export const ACTIVEID = "ACTIVEID";
export const ADMIN_SIDEBAR_SCROLL_POSITION = "ADMIN_SIDEBAR_SCROLL_POSITION";
export const ADMIN_ACTIVE_SIDEBAR_MENU = "ADMIN_ACTIVE_SIDEBAR_MENU";

